var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 51V33.15H0V17.85C0 16.4475 0.514062 15.2469 1.54219 14.2481C2.57031 13.2494 3.80625 12.75 5.25 12.75H15.75C17.1937 12.75 18.4297 13.2494 19.4578 14.2481C20.4859 15.2469 21 16.4475 21 17.85V33.15H14.4375V51H6.5625ZM10.5 10.2C9.05625 10.2 7.82031 9.70062 6.79219 8.70187C5.76406 7.70312 5.25 6.5025 5.25 5.1C5.25 3.6975 5.76406 2.49688 6.79219 1.49812C7.82031 0.499375 9.05625 0 10.5 0C11.9437 0 13.1797 0.499375 14.2078 1.49812C15.2359 2.49688 15.75 3.6975 15.75 5.1C15.75 6.5025 15.2359 7.70312 14.2078 8.70187C13.1797 9.70062 11.9437 10.2 10.5 10.2Z",
    fill: "#7F9D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIcon);
export default __webpack_public_path__ + "static/media/individual-icon.c2f6ce485dd2290e20bf6f4ac320b714.svg";
export { ForwardRef as ReactComponent };